import type {MessageAudio} from "@khan/guide-types";

/**
 * Represents a map where each entry is a pair of audioKey and MessageAudio.
 */
class AudioCache extends Map<string, MessageAudio> {
    constructor(initialValues: Iterable<[string, MessageAudio]> = []) {
        super(initialValues);
    }
}

export {AudioCache};
